import React, { useEffect, useState } from "react";
import { NavbarNew } from "./navbar";
import sec1Img from "../../images/homepage/sec1Img.png";
import arrowRight from "../../images/homepage/arrowRight.svg";
import InstrctorIco from "../../images/homepage/InstrctorIco.svg";
import availableIco from "../../images/homepage/availableIco.svg";
import earningIco from "../../images/homepage/earningIco.svg";
import sec3Img1 from "../../images/homepage/sec3Img1.png";
import sec3Img2 from "../../images/homepage/sec3Img2.png";
import sec3Img3 from "../../images/homepage/sec3Img3.png";
import sec3Img4 from "../../images/homepage/sec3Img4.png";

import article1 from "../../images/homepage/article1.jpg";
import article2 from "../../images/homepage/article2.png";
import article3 from "../../images/homepage/article3.png";
import animation1sec1 from "../../images/homepage/animation1sec.mp4";
import animation1sec from "../../images/homepage/animation1sec.webm";
import Animation2sec1 from "../../images/homepage/Animation2sec1.webm";
import Animation2WithBg from "../../images/homepage/Animation2WithBg.mp4";
import facebookIco from "../../images/homepage/facebookIco.svg";
import anouncementImg from "../../images/anouncement.png";

import { Link } from "react-router-dom";
import EducationalVideosNew from "./educationalContent";
import { Modal } from "react-bootstrap";
import { SocialModal } from "../modals/socialModal";
import userAction from "../../redux/users/action";
import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "react-alert";
import copy from "copy-to-clipboard";
import api from "../../api";
import { AnnualModal } from "../modals/annualModal";
import { MonthlyModal } from "../modals/monthlyModal";
import { BroadcastModal } from "../modals/broadcastModal";
import Slider from "react-slick";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import animate from "../../assets/js/animate";
import LiveBTCChart from "./btcChart";
import { BTCCalculator } from "../calculators/ifInvestCalculator";

export const HomeNew = () => {
  const userStore = useSelector((state) => state.userReducer);

  const { setUser } = userAction;
  const dispatch = useDispatch();
  const alert = useAlert();
  const [loader, setLoader] = useState(false);
  const [copyText, setCopyText] = useState("Copy to clipboard");
  const [walletInput, setWalletInput] = useState("");

  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showAddWallet, setShowAddWallet] = useState(false);
  const handleCloseAddWallet = () => setShowAddWallet(false);
  const handleShowAddWallet = () => setShowAddWallet(true);

  const [showBroadcast, setShowBroadcast] = useState(false);
  const handleCloseBroadcast = () => setShowBroadcast(false);
  const handleShowBroadcast = () => setShowBroadcast(true);

  const [formSubmitted, setformSubmitted] = useState(false);
  const [showYearly, setShowYearly] = useState(false);
  const handleCloseYearly = () => {
    setShowYearly(false);
    setTimeout(() => {
      setformSubmitted(false);
    }, 1000);
  };
  const handleShowYearly = () => {
    setShowYearly(true);
    handleClose();
  };

  const [showMonthly, setShowMonthly] = useState(false);
  const handleCloseMonthly = () => {
    setShowMonthly(false);
    // handleShowBroadcast();
  };
  const handleShowMonthly = () => {
    setShowMonthly(true);
    handleClose();
  };

  const [showVideo, setShowVideo] = useState(false);
  const handleCloseVideo = () => {
    setShowVideo(false);
    // {!userStore?.users?.user?.name &&
    //   handleShowWallet(true)
    // }
    handleShowBroadcast();
  };

  const handleCopy = (text) => {
    copy(text);
    setCopyText("Copied");
    setTimeout(() => {
      setCopyText("Copy to clipboard");
    }, 3000);
  };

  const addWallet = async () => {
    try {
      if (!walletInput) {
        alert.show("Please add TRC wallet address");
        return;
      }
      setLoader(true);
      // let balance = await checkBalance(walletInput)
      // console.log(balance);

      // if(balance < 100) {
      //   alert.show("Your do not have enough balance to get VIP access")
      //   setLoader(false)
      //   return
      // }

      let payload = {
        _id: userStore?.users?.user?._id,
        wallet: walletInput,
      };

      const signalResponse = await api.userEdit(payload);
      // console.log(signalResponse);
      if (signalResponse?.success) {
        let updatedData = userStore?.users;
        updatedData.user.wallet = payload.wallet;
        dispatch(setUser(updatedData));
        handleCloseAddWallet();
        alert.show("Your Wallet Address Has Been Added");
        // navigate("/post")
      } else {
        alert.show(signalResponse?.msg);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      // handleCloseAddWallet()
      alert.show(error.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    // {!userStore?.users?.user?.name &&
    //   handleShowVideo()
    // }
    // {(userStore?.users?.user?.name && !userStore?.users?.user?.wallet) &&
    //   handleShowAddWallet()
    // }
  }, []);
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000,
  };

  useEffect(() => {
    animate();
  }, []);
  return (
    <>
      <div className="homepageNew">
        <div className="homeSec1">
          <div className="container">
            <Marquee />

            <div className="row ai-center">
              <div className="col-lg-6">
                <div className="content">
                  <div className="tagline animatable slideInUp ">
                    FOR A BETTER FUTURE
                  </div>
                  <div className="heading animatable slideInUp animationDelay100">
                    Knowledge <span>First</span>, Profits <span>Follow</span>
                  </div>
                  <div className="disclaimer">
                    <p className="animatable slideInUp animationDelay100">
                      <b>We cannot make you a millionaire.</b> We cannot promise
                      to double your money. If you have come here with the
                      expectation that we will turn you into a millionaire, that
                      is not the case.
                    </p>
                    <p className="animatable slideInUp animationDelay100">
                      We do not make any promises or guarantees regarding
                      profits, returns, or making you a millionaire. You are
                      solely responsible for your own trading decisions,
                      profits, and losses. We simply share how we trade and the
                      methods we personally use.{" "}
                    </p>
                    <p className="animatable slideInUp ">
                      <span>DISCLAIMER: </span>
                      You are paying solely to access our content. We are not
                      your coach, teacher, or mentor. We are not financial
                      advisors, portfolio managers, or a fund. We engage in day
                      trading of stocks and cryptocurrencies (both spot and
                      futures).{" "}
                    </p>

                    <p className="animatable slideInUp animationDelay100">
                      Becoming a millionaire depends on your{" "}
                      <b>own hard work, discipline, and destiny.</b> What we
                      provide are the tools, knowledge, and insights but your
                      success will always be the result of your own effort and
                      determination.
                    </p>
                    <p className="animatable slideInUp animationDelay200">
                      We are not a university or a degree program and do not
                      claim to replace the value of studying at institutions
                      like Stanford, Harvard, Cambridge, or Oxford.{" "}
                    </p>
                    <div
                      className=" more cursor-pointer animatable slideInUp animationDelay300"
                      onClick={handleShowMore}
                    >
                      See More
                    </div>
                  </div>
                  <div className="socialModal ms-0 pb-0">
                    <div className="row">
                      <div className="col-6">
                        <MonthlySession />
                      </div>
                      <div className="col-6">
                        <a
                          className="annual socialL"
                          onClick={handleShowYearly}
                        >
                          <img src={facebookIco} alt="" />
                          Annual Group
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="explore" onClick={handleShow}>
                    {/* <div className="text">Explore Our Channels</div> */}
                    <div className="text">Join Our Free Crypto Updates</div>
                    <div className="next">
                      <img src={arrowRight} alt="mext" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="imgDiv logo">
                  <video
                    playsInline
                    webkit-playsinline
                    controls={false}
                    src={Animation2sec1}
                    autoPlay
                    loop
                    muted
                    className="w-100 "
                  />
                </div>
                {/* <Slider {...settings}>
                  <div className="imgDiv">
                    <video
                      playsInline
                      webkit-playsinline
                      controls={false}
                      src={animation1sec}
                      autoPlay
                      loop
                      muted
                      className="w-100"
                    />
                  </div>
                  <div className="imgDiv">
                    <video
                      playsInline
                      webkit-playsinline
                      controls={false}
                      src={animation1sec1}
                      autoPlay
                      loop
                      muted
                      className="w-100"
                    />
                  </div>
                </Slider> */}
              </div>
            </div>

            <Marquee2 />
          </div>
        </div>

        <section className="articleSec">
          <div className="container">
            <div className="homeHeading text-center animatable slideInUp ">
              Team <span> Acknowledgements</span>
            </div>

            <div className="row jc-center">
              <div className="col-lg-4 mb-3 text-center animatable flipInY  ">
                <a
                  className="imgDiv"
                  href="https://www.youtube.com/watch?v=eZ0dFzxXTV4"
                  target="_blank"
                >
                  <div className="layout"></div>

                  <img src={article2} alt="" />
                  <div className="content">
                    <div className="date">21 March 2022</div>
                    <div className="title">
                      Crypto Stories: Pakistani crypto billionaire wants his
                      country to be less reliant on credit
                    </div>
                    <div className="desc">
                      Waqar Zaka – Pakistan’s ex-crypto advisor and a winning
                      leverage trader.
                    </div>
                    <a className="learnMore">Learn More</a>
                  </div>
                </a>
              </div>

              <div className="col-lg-4 mb-3 text-center animatable flipInY animationDelay100">
                <a
                  className="imgDiv"
                  href="https://www.samaa.tv/2087313031-waqar-zaka-makes-millions-amidst-crypto-market-turmoil"
                  target="_blank"
                >
                  <img src={article3} alt="" />
                  <div className="content">
                    <div className="date">14 April 2024</div>
                    <div className="title">
                      Waqar Zaka makes millions amidst Bitcoin crash
                    </div>
                    <a className="learnMore">Learn More</a>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 mb-3 text-center animatable flipInY animationDelay200">
                <a
                  className="imgDiv"
                  href="https://dunyanews.tv/amp/english/853790.php"
                  target="_blank"
                >
                  <div className="layout"></div>
                  <img src={article1} alt="" />
                  <div className="content">
                    <div className="date">30 Nov 2024</div>
                    <div className="title">
                      Waqar Zaka continues his profit streak on cryptocurrency.
                    </div>
                    <a className="learnMore">Learn More</a>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="homeSec2">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 mb-4 animatable flipInY ">
                <div className="sec2Ca one">
                  <div className="ico">
                    <img src={InstrctorIco} alt="Instrctor" />
                  </div>
                  <div className="title">Instructors</div>
                  <div className="text">
                    Benefit from 7+ years of experience and the wisdom of our
                    seasoned instructors who are dedicated to guiding and
                    educating you.
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4 animatable flipInY animationDelay200">
                <div className="sec2Ca two">
                  <div className="ico">
                    <img src={availableIco} alt="available" />
                  </div>
                  <div className="title">
                    Available During PAK Working Hours
                  </div>
                  <div className="text">
                    {/* Please note that our session timing has been changed from
                    03:00 PM to 05:30 PM PKT (Monday to Friday). */}
                    Please note that our session timing has been changed.
                  </div>
                  <div className="text mt-2">
                    New Timing: 9:00 PM PKT & 11:00 PM PKT
                  </div>
                  <div className="text mb-2">Days: Monday to Friday</div>
                  <div className="text mb-2">
                    Please note: Saturday and Sunday – No session.
                  </div>
                  <div className="text">
                    Thank you for your cooperation and happy learning!
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4 animatable flipInY animationDelay300">
                <div className="sec2Ca three">
                  <div className="ico">
                    <img src={earningIco} alt="earning" />
                  </div>
                  <div className="title">Warning</div>
                  <div className="text">
                    Warning: As per 2024 data, only 6.8% of people worldwide are
                    able to engage in and fully understand crypto work.
                    Additionally, 80% to 90% of day traders end up in losses.
                    Why? Because the majority are unwilling to practice demo
                    trades before diving in. If you want to succeed, you must
                    develop patience and focus on practicing trades with minimal
                    investments rather than going all in. Smart and disciplined
                    trading is the key to long term success in the volatile
                    crypto market.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="homeSec3" id="services">
          <div className="container">
            <div className="homeHeading animatable slideInUp ">
              Explore our <span> education services</span>
            </div>
            <div className="row jc-center">
              <div className="col-md-4 animatable flipInY ">
                <div className="sec3Card">
                  <div className="imgDiv">
                    <img src={sec3Img1} alt="" />
                  </div>
                  <div className="title animatable slideInUp">Block Chain</div>
                  <div className="desc animatable slideInUp animationDelay100">
                    Learn Blockchain and Revolutionize Possibilities Across
                    Industries!
                  </div>
                </div>
              </div>
              <div className="col-md-4 animatable flipInY animationDelay100">
                <div className="sec3Card">
                  <div className="imgDiv">
                    <img src={sec3Img2} alt="" />
                  </div>
                  <div className="title animatable slideInUp ">
                    Spot Trading
                  </div>
                  <div className="desc animatable slideInUp animationDelay100">
                    Master the Art of Spot Trading and Ride the Currents of
                    Market Opportunities!
                  </div>
                </div>
              </div>
              <div className="col-md-4 animatable flipInY animationDelay300">
                <div className="sec3Card">
                  <div className="imgDiv">
                    <img src={sec3Img3} alt="" />
                  </div>
                  <div className="title animatable slideInUp ">
                    Future Trading
                  </div>
                  <div className="desc animatable slideInUp animationDelay100">
                    Dive into the World of Future Trading and Unlock Tomorrow's
                    Profits Today
                  </div>
                </div>
              </div>
              <div className="col-md-4 animatable flipInY animationDelay100">
                <div className="sec3Card">
                  <div className="imgDiv">
                    <img src={sec3Img4} alt="" />
                  </div>
                  <div className="title animatable slideInUp ">
                    Get Education about Stock & Commodities Market
                  </div>
                  <div className="desc animatable slideInUp animationDelay100">
                    Get Expert education by Team WZ. Learn & Grow!
                  </div>
                </div>
              </div>
              {/* <div className="col-md-4">
                <div className="sec3Card">
                  <div className="imgDiv">
                    <img src={sec3Img5} alt="" />
                  </div>
                  <div className="title">Amazon</div>
                  <div className="desc">
                    Learn Amazon From A to Z and Discover Limitless
                    Opportunities!
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="sec3Card">
                  <div className="imgDiv">
                    <img src={sec3Img6} alt="" />
                  </div>
                  <div className="title">Meta Verse</div>
                  <div className="desc">
                    Step into the Metaverse and Shape Your Own Infinite Digital
                    Universe!
                  </div>
                </div>
              </div> */}
            </div>
            {/* <div className="text-center">
              <button className="themeBlackBtn">See More</button>
            </div> */}
          </div>
        </section>

        <div className="container">
          <BTCCalculator />
        </div>

        <div className="container">
          <section className="homeSec4" id="about">
            <div className="homeHeading animatable slideInUp ">About</div>
            {/* <img className="effect" src={sec4Circle} alt="" /> */}
            <div className="row ai-center">
              <div className="col-lg-7 order-2 order-lg-1">
                <div className="title animatable slideInUp animationDelay100">
                  <b>We are a team</b> of experienced analysts providing expert
                  insights into blockchain, spot trading, and futures trading.
                  Our goal is to equip you with valuable market analysis,
                  trends, and strategies to help you stay ahead in the crypto
                  space.
                </div>

                <div className="desc mb-0 animatable slideInUp animationDelay200">
                  Stay Informed, Stay Ahead.
                </div>
                <div className="desc mt-3 animatable slideInUp animationDelay300">
                  While we share in-depth market insights and trading
                  strategies, we are not financial advisors. Our analysis is
                  based on research and industry trends, empowering you to make
                  informed decisions.
                </div>
                <Link
                  className="themeWhiteBtn animatable slideInUp animationDelay400"
                  to={"/signup"}
                >
                  Enroll Now
                </Link>
              </div>
              <div className="col-lg-5 order-1 order-lg-2">
                <div className="imgDiv">
                  {/* <img src={sec4Img} alt="" /> */}
                  <video
                    playsInline
                    webkit-playsinline
                    controls={false}
                    src={Animation2WithBg}
                    autoPlay
                    loop
                    muted
                    className="w-100"
                  />
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="container">
          <TelegramUpdates />
        </div>

        <div className="container">
          <div className="btcLiveChart">
            <LiveBTCChart heading={true} />
          </div>
        </div>

        {/* <section className="homeSec5">
          <div className="container">
            <div className="homeHeading">Our educational content</div>
            <EducationalVideosNew />
            <div className="text-center mt-4">
              <Link className="themeBlackBtn" to={"/signup"}>
                Enroll Now
              </Link>
            </div>
          </div>
        </section> */}

        {/* <div className="container">
          <section className="homeSec6" id="testimonial">
            <div className="row">
              <div className="col-lg-6">
                <div className="imgdiv">
                  <div className="icon active">
                    <img src={review1} alt="" />
                  </div>
                  <div className="icon one">
                    <img src={review2} alt="" />
                  </div>
                  <div className="icon two">
                    <img src={review3} alt="" />
                  </div>
                  <div className="icon three">
                    <img src={review2} alt="" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="reviewIco">
                  <img src={reviewIco} alt="" />
                </div>
                <div className="desc">
                  Since 1985 Reed has pioneered specialist recruitment, Sourcing
                  knowledgeable, skilled professionals pioneered Specialist
                  recruitment, sourcing.
                </div>
                <div className="nameM">
                  <div className="name">Victoria Wotton</div>
                  <div>
                    <div className="desig">Fementum Odio Co.</div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div> */}
      </div>

      <Modal size="lg" show={showMore} onHide={handleCloseMore} centered>
        <Modal.Body>
          <div className="otpModalMain broadcastModal">
            <div className="closeIcon" onClick={handleCloseMore}>
              <i className="fa-solid fa-xmark" />
            </div>

            <div className="showMoreModalM">
              <div className="showMoreModal py-4">
                <p className="desc1">
                  Our course is based on insights from renowned books, including
                  Misbehaving by Richard H. Thaler (Nobel Prize winner), Inside
                  the Investor’s Brain by Richard L. Peterson, Adaptive Markets
                  by Andrew W. Lo, and Thinking, Fast and Slow by Daniel
                  Kahneman (Nobel Prize winner). We also take inspiration from
                  Stanford University’s FINANCE 305: Capital Markets and
                  Institutional Investing and Bloomberg Terminal for market data
                  analysis.
                </p>
                <p className="desc1">
                  By joining our paid program, you will gain access to real-time
                  investment insights from Waqar Zaka, a day trader and
                  early-stage investor in crypto projects. Some days, you may
                  see multiple spot and futures trades; other times, there may
                  be no trades for weeks—it all depends on market conditions.
                  There is no fixed schedule for trades, and this is not a
                  signal group. Waqar Zaka shares where he is investing, and you
                  must make your own decisions based on your financial knowledge
                  and risk tolerance.
                </p>
                <p className="desc1">
                  This program includes both text-based learning and video
                  content, with live market updates twice a day where we
                  showcase real-time trades. However, we do not guarantee
                  profits or financial success. Like a gym membership, results
                  depend on individual effort—only those who actively learn and
                  apply the knowledge may benefit.
                </p>
                <p className="desc1">
                  Important: We will never ask you to send money to us or any
                  individual claiming to be Waqar Zaka. We are an educational
                  platform, not portfolio managers. If you seek portfolio
                  management services, consider professional firms like
                  BlackRock USA.
                </p>
                <p>
                  No Refund Policy: There are no refunds under any
                  circumstances. It is your responsibility to thoroughly
                  research before purchasing a subscription. This paid service
                  only provides exclusive content on where and how Waqar Zaka is
                  investing—it does not guarantee profits. No one in the world
                  can guarantee returns; if someone claims otherwise, they are
                  scammers. If guaranteed profits were possible, firms like
                  BlackRock would advertise them—yet they don’t, because such
                  guarantees do not exist.
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showAddWallet} onHide={handleCloseAddWallet} centered>
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleCloseAddWallet}>
              <i className="fa-solid fa-xmark" />
            </div>

            {/* <h3 className="title color-dark mb-0">For VIP Access</h3> */}
            {/* <p className="teather mb-0 text-center">Please add TRC Wallet Address</p> */}
            {/* <p className='mt-2'>Please note: Access to VIP services requires a minimum wallet balance of 100 USDT. If your balance is below this amount, you will not be able to access VIP services.</p> */}
            <h3 className="title color-dark mb-0">For Copy Trade</h3>
            <p className="mt-2">
              Do you want to copy Waqar Zaka's trades? If yes, then provide the
              address of your USDT (TRC) wallet with a balance of 100 USDT.
            </p>
            <div className="form-group my-4">
              <input
                type="text"
                onChange={(e) => setWalletInput(e.target.value)}
                className="form-control"
                placeholder="Address..."
              />
            </div>
            <div className="text-center">
              <button
                className="default-btn loaderBtn"
                disabled={loader ? true : false}
                onClick={addWallet}
              >
                {loader && <i className="fa fa-spinner fa-pulse mx-2"></i>}
                Add Wallet
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <AnnualModal
        show={showYearly}
        handleClose={handleCloseYearly}
        formSubmitted={formSubmitted}
        setformSubmitted={setformSubmitted}
      />

      <MonthlyModal
        showMonthly={showMonthly}
        handleCloseMonthly={handleCloseMonthly}
      />

      <BroadcastModal
        showBroadcast={showBroadcast}
        handleCloseBroadcast={handleCloseBroadcast}
      />

      <SocialModal show={show} handleClose={handleClose} />
    </>
  );
};

const TelegramUpdates = () => {
  /* ===== Telegram (Waqar Zaka) ===== */

  const [tgData, setTgData] = useState([]);
  const TG_USERNAMES = ["waqarzaka", "WaqarZaka", "Waqar_Zaka"];
  var tgTimer = null;

  function timeAgo(ts) {
    var d = ts instanceof Date ? ts : new Date(ts),
      s = Math.floor((Date.now() - d) / 1000);
    if (s < 60) return s + "s ago";
    var m = Math.floor(s / 60);
    if (m < 60) return m + "m ago";
    var h = Math.floor(m / 60);
    if (h < 24) return h + "h ago";
    var dd = Math.floor(h / 24);
    return dd + "d ago";
  }
  const trunc = (s, n) =>
    s && s.length > n ? s.slice(0, n - 1) + "…" : s || "";

  function refreshTelegram() {
    fetchTelegramOnce(TG_USERNAMES)
      .then(renderTelegram)
      .catch(() => {
        let tgTicker = document.getElementById("tg-ticker");
        tgTicker.innerText = "Unable to load Telegram.";
      });
  }

  function startTelegramLoop() {
    if (tgTimer) clearInterval(tgTimer);
    refreshTelegram();
    tgTimer = setInterval(refreshTelegram, 120000);
  }

  function fetchTelegramOnce(usernames, idx = 0) {
    if (idx >= usernames.length) return Promise.resolve([]);
    var u = usernames[idx];
    return fetchFeedRaw("https://t.me/s/" + encodeURIComponent(u))
      .then((html) => {
        var items = parseTelegramHTML(html, u);
        if (items.length) return items;
        return fetchTelegramOnce(usernames, idx + 1);
      })
      .catch(() => fetchTelegramOnce(usernames, idx + 1));
  }

  function fetchFeedRaw(u) {
    var p1 = "https://api.allorigins.win/raw?url=" + encodeURIComponent(u),
      p2 = "https://api.allorigins.space/raw?url=" + encodeURIComponent(u);
    return fetch(p1)
      .then((r) => {
        if (!r.ok) throw 0;
        return r.text();
      })
      .catch(() => fetch(p2).then((r) => r.text()));
  }

  function renderTelegram(items) {
    // var el = $("tg-ticker");
    var el = document.getElementById("tg-ticker");
    if (!items.length) {
      el.innerHTML = `<span class="anounce"><img src=${anouncementImg} /></span> <span class="tag"><i class="fa-brands fa-telegram" ></i></span> No recent messages found.`;
      return;
    }
    setTgData(items);
    // el.innerHTML = items
    //   .map(
    //     (it) =>
    //       `<div class="tg-item"><span class="anounce"><img src=${anouncementImg} /></span> <span class="tag"><i class="fa-brands fa-telegram" ></i></span>` +
    //       '<a href="' +
    //       it.link.replace(/"/g, "&quot;") +
    //       '" target="_blank" rel="noopener">' +
    //       trunc(it.text, 140) +
    //       "</a>" +
    //       '<span class="tg-meta"> (' +
    //       timeAgo(it.date) +
    //       ")</span></div>"
    //   )
    //   .join("");
  }

  function refreshTelegram() {
    fetchTelegramOnce(TG_USERNAMES)
      .then(renderTelegram)
      .catch(() => {
        let tgTicker = document.getElementById("tg-ticker");

        tgTicker.innerText = "Unable to load Telegram.";
      });
  }

  function startTelegramLoop() {
    if (tgTimer) clearInterval(tgTimer);
    refreshTelegram();
    tgTimer = setInterval(refreshTelegram, 120000);
  }

  function parseTelegramHTML(html, usernameTried) {
    var out = [];
    try {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var blocks = doc.querySelectorAll(".tgme_widget_message_wrap");
      blocks.forEach((b) => {
        var textEl = b.querySelector(".tgme_widget_message_text");
        var dateA = b.querySelector("a.tgme_widget_message_date");
        var timeEl = dateA ? dateA.querySelector("time") : null;
        var href = dateA ? dateA.getAttribute("href") : "";
        var dt = timeEl ? timeEl.getAttribute("datetime") : "";
        var txt = textEl ? textEl.textContent.trim() : "";
        if (txt) {
          out.push({
            text: txt.replace(/\s+/g, " ").trim(),
            link: href || "https://t.me/" + usernameTried,
            date: dt ? new Date(dt) : new Date(),
          });
        }
      });
    } catch (e) {}
    out.sort((a, b) => +b.date - +a.date);
    return out.slice(0, 3);
  }

  const getHeading = (str) => {
    return str.split(" ").slice(0, 3).join(" ");
  };

  useEffect(() => {
    startTelegramLoop();
  }, []);

  return (
    <>
      <div className="telegramUpdateSec">
        {/* <div className="lNews animatable slideInUp ">Latest News</div> */}
        <div className="headRow">
          <h1 className="homeHeading animatable slideInRight ">
            Waqar Zaka Telegram Updates.
          </h1>
          <a
            href="https://t.me/waqarzaka"
            target="_blank"
            className="btn followBtn animatable slideInLeft "
          >
            Follow Us On Telegram
          </a>
        </div>
        {tgData.length > 0 ? (
          <div className="row">
            {tgData.map((item, key) => (
              <div className="col-lg-4 col-sm-6 mb-3" key={key}>
                <a
                  href={item?.link.replace(/"/g, "&quot;")}
                  target="_blank"
                  className="newsCard "
                >
                  <div className="title">
                    {item?.text && getHeading(item?.text)}
                  </div>
                  <div className="desc">{trunc(item?.text, 100)}</div>
                  <div className="readRow">
                    <div className="d-flex ai-center">
                      <div className="text">Read More</div>
                      <div className="icon">
                        <i className="fa-solid fa-arrow-right-long"></i>
                      </div>
                    </div>
                    <div className="time">
                      {item?.date && timeAgo(item?.date)}
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        ) : (
          <div id="strip">
            <div className="strip-row">
              <div id="news-ticker" className=""></div>
              <div id="tg-ticker" className=""></div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const Marquee = () => {
  const content =
    "📢 Ramadan Live Session Update, Our Ramadan live session timings have been updated - New Timings, 10:00 PM PKT and 12:30 AM PKT, Days - Monday to Friday, Please note: Saturday and Sunday – No session.";

  return (
    <div className="marquee-container bg-purple py-2 text-white border-top border-bottom">
      <div className="marquee-content">
        {/* We repeat the text to ensure there is no gap during the loop */}
        <span className="marquee-text">{content}</span>
        <span className="marquee-text">{content}</span>
        <span className="marquee-text">{content}</span>
      </div>
    </div>
  );
};
const Marquee2 = () => {
  const content =
    "📢 New Feature Added, We have introduced a Profile Page on our platform. You can now easily update and manage your personal details directly from your account profile page.";

  return (
    <div className="marquee-container2">
      <div className="marquee-container bg-purple py-2 text-white border-top border-bottom">
        <div className="marquee-content">
          {/* We repeat the text to ensure there is no gap during the loop */}
          <span className="marquee-text">{content}</span>
          <span className="marquee-text">{content}</span>
          <span className="marquee-text">{content}</span>
        </div>
      </div>
    </div>
  );
};

const MonthlySession = () => {
  const alert = useAlert();
  const [loader, setLoader] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoader(true);
      const stripeRes = await api.directPaySession();
      // console.log(stripeRes);

      if (!stripeRes?.link) {
        throw new Error("Something went wrong");
      }

      window.open(stripeRes?.link, "_self");

      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "SOMETHING WENT WRONG.");
      setLoader(false);
    }
  };

  return (
    <>
      {loader ? (
        <Link
          // to={"/signup"}
          className="monthly socialL"
        >
          <i
            className="fa fa-spinner fa-pulse mx-2 mb-1"
            style={{ position: "relative", top: "-0px" }}
          ></i>
          MONTHLY GROUP
        </Link>
      ) : (
        <Link
          // to={"/signup"}
          className="monthly socialL"
          onClick={handleSubmit}
        >
          MONTHLY GROUP
        </Link>
      )}
    </>
  );
};
